import { useSelector } from 'react-redux';
import { Divider } from '@heroui/react';
import { ContentWrapper } from '@/widgets/ContentWrapper';
import { useGetProgrammesQuery, useGetRecommendedCoursesQuery } from '@/entities/Dashboard';
import { useGetBlogsQuery } from '@/entities/Blog';
import { useGetTeacherCoursesQuery } from '@/entities/TeacherCourses';
import { useGetTeacherAssignmentsQuery } from '@/entities/TeacherAssignment';
import { getMyProfile, isProfileStaff, isProfileStudent } from '@/entities/Profile';
import { Section } from '@/shared/ui/Section';
import { HomeBlogs } from '../HomeBlogs';
import { StudentRecommendedCourses } from '../StudentRecommendedCourses';
import { HomeGreeting } from '../HomeGreetings';
import { StudentProgrammes } from '../StudentProgrammes';
import { TeacherAssignmentsTests } from '../TeacherAssignmentsTests';
import { TeacherProgrammes } from '../TeacherProgrammes';

export const HomeView = () => {
  const user = useSelector(getMyProfile);
  const isStudent = isProfileStudent(user);
  const isTeacher = isProfileStaff(user);

  const { data: studentProgrammes, isLoading: isLoadingStudentProgram } = useGetProgrammesQuery(
    undefined,
    {
      skip: !isStudent,
    },
  );
  const { data: studentRecommendedCourses, isLoading: isLoadingStudentRecommended } =
    useGetRecommendedCoursesQuery(undefined, { skip: !isStudent });

  const { data: teacherCourses, isLoading: isLoadingTeacherProgram } = useGetTeacherCoursesQuery(
    undefined,
    {
      skip: !isTeacher,
    },
  );
  const { data: teacherAssignments, isLoading: isLoadingAssignments } =
    useGetTeacherAssignmentsQuery(undefined, {
      skip: !isTeacher,
    });
  const {
    data: blogs,
    isLoading: isLoadingBlogs,
    isError: isBlogsError,
    isSuccess: isBlogsSuccess,
  } = useGetBlogsQuery({ page: 1, pageSize: 12 }, { skip: !isStudent });

  return (
    <ContentWrapper
      isLoading={
        isLoadingStudentProgram ||
        isLoadingStudentRecommended ||
        isLoadingTeacherProgram ||
        isLoadingAssignments
      }
      className="flex flex-col gap-y-6"
    >
      <Section typeSection="section" className="flex flex-col gap-y-6">
        <HomeGreeting />
        <Divider as="div" className="h-[2px] bg-neutral-hover" />
        {isStudent ? (
          <StudentProgrammes programmes={studentProgrammes || []} />
        ) : (
          <TeacherProgrammes courses={teacherCourses} />
        )}
      </Section>
      {isStudent ? (
        <>
          {studentRecommendedCourses && studentRecommendedCourses.length > 0 && (
            <StudentRecommendedCourses courses={studentRecommendedCourses} />
          )}
          <HomeBlogs
            articles={blogs?.articles}
            isLoading={isLoadingBlogs}
            isError={isBlogsError}
            isSuccess={isBlogsSuccess}
          />
        </>
      ) : (
        <TeacherAssignmentsTests items={teacherAssignments?.intakes} />
      )}
    </ContentWrapper>
  );
};
